import { IProductDto } from '../model/IProductDto';
import { axiosMod, getPublicApiUrl } from '../utility';

export interface IProductApi {
  getById(id: number): Promise<IProductDto>;
}

export class ProductApi implements IProductApi {
  private endpointUrl: string;

  constructor() {
    this.endpointUrl = getPublicApiUrl('/product');
  }

  async getById(id: number): Promise<IProductDto> {
    const response = await axiosMod().get<IProductDto>(
      `${this.endpointUrl}/${id}`
    );

    return response.data;
  }
}
